export default {
  nodes: {
    zh: '服务管理',
    en: 'Services',
  },
  addNode: {
    zh: '添加服务',
    en: 'Add Service',
  },
  editNode: {
    zh: '编辑服务',
    en: 'Edit Service',
  },
  nodeName: {
    zh: '服务名称',
    en: 'Service name',
  },
  nodeType: {
    zh: '服务类型',
    en: 'Service type',
  },
  currentNode: {
    zh: '当前服务',
    en: 'Current Service',
  },
  nullNodesText: {
    zh: '目前没有受管理的 Kuiper 实例，请点击添加按钮来新增被管理的 Kuiper 服务',
    en: 'There is currently no managed Kuiper instance, please click the Add button to add a managed Kuiper service',
  },
  endpoint: {
    zh: '端点 URL',
    en: 'Endpoint',
  },
  secretEditRequired: {
    zh: '为确保编辑服务时的安全性，请重新输入 Secret',
    en: 'In order to ensure the security when editing the service, please re-enter the Secret',
  },
  normalHttpRest: {
    zh: '直接连接服务',
    en: 'Direct link service',
  },
  huaweiIef: {
    zh: '华为 IEF 服务',
    en: 'Huawei IEF service',
  },
  channel: {
    zh: '通道类型服务',
    en: 'Channel service',
  },
  ruleset: {
    zh: '规则集',
    en: 'Ruleset',
  },
  importRuleset: {
    zh: '导入规则集',
    en: 'Import ruleset',
  },
  exportRuleset: {
    zh: '导出规则集',
    en: 'Export rulesets',
  },
  importText: {
    zh: '文本内容',
    en: 'Text Content',
  },
  importURL: {
    zh: '文件 URL',
    en: 'FIle URL',
  },
}
